import { Component } from 'react';
import MonacoEditor from 'react-monaco-editor';
import { T, COMMON } from '../../common/js/i18n';

interface Props {
    onClose?: () => void;
}

interface State {
}


const demoTemplateCode = `
name: <%=name%>
`;

export default class TemplateHelp extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }
    render() {
        let resizeListener: any = undefined;
        return (
            <div style={{ padding: "0.5em" }}>
                <p style={{ marginTop: "0.5em", marginBottom: "0.5em" }}>
                    {T({
                        en: (<span>The template engine is a Lua library named "etlua", For syntax, refer to <a href="https://github.com/leafo/etlua" target="_blank" rel="noreferrer">https://github.com/leafo/etlua</a>.</span>),
                        zh: (<span>模板引擎是基于lua语言的一个库etlua，语法请参考<a href="https://github.com/leafo/etlua" target="_blank" rel="noreferrer">https://github.com/leafo/etlua</a>。</span>)
                    })}
                </p>
                {T({
                    en: "Demo template code",
                    zh: "Demo模板代码"
                })}:
                <MonacoEditor
                    width="100%"
                    height="8em"
                    language="lua"
                    theme="vs-dark"
                    value={demoTemplateCode}
                    options={{
                        selectOnLineNumbers: true,
                        readOnly: true
                    }}
                    onChange={(newVal: any, e: any) => {
                        this.setState({
                            value: newVal
                        });
                    }}
                    editorDidMount={(editor, monaco) => {
                        if (!resizeListener) {
                            resizeListener = () => {
                                editor.layout();
                            };
                            window.addEventListener("resize", resizeListener);
                        }
                    }}
                    editorWillUnmount={() => {
                        if (resizeListener) {
                            window.removeEventListener("resize", resizeListener);
                            resizeListener = undefined;
                        }
                    }}
                />
                <div style={{ textAlign: "center", paddingTop: '0.5em' }}>
                    <button type="button" className="btn" onClick={() => {
                        if (this.props.onClose) {
                            this.props.onClose();
                        }
                    }}>{T(COMMON.CLOSE)}</button>
                </div>
            </div>
        );
    }
}
